
export const CALLHISTOY= [
    { 'id': 1, date: '20/12/2021',},
    { 'id': 1, date: '20/12/2021',},
    { 'id': 1, date: '20/12/2021',},
    { 'id': 1, date: '20/12/2021',},
    { 'id': 1, date: '20/12/2021',},
]